import { useEffect, useState, useRef } from "react";
import getServices from "../../Services/get-service";

function SelectBank({ value, onChange, bName, disabled }) {
  const [bank, setBank] = useState([]);
  const [displayValue, setDisplayValue] = useState("");
  const [searchText, setSearchText] = useState("");
  const [showList, setShowList] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    getServices.getAllBank().then(
      (response) => {
        setBank(response.data.data || []);
      },
      (error) => { }
    );
  }, []);

  useEffect(() => {
    if (!value) {
      setDisplayValue("");
      setSearchText("");
    } else if (bank.length > 0) {
      const selected = bank.find((item) => item.bankCode === value);
      if (selected) {
        setDisplayValue(selected.bankName);
        setSearchText(selected.bankName);
      }
    }
  }, [value, bank]);

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowList(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  function handleChange(event) {
    const text = event.target.value;
    setSearchText(text);
    setDisplayValue(text);
    setShowList(true);
    if (text === "") {
      onChange("");
      bName("");
    }
  }

  const handleSelect = (item) => {
    onChange(item.bankCode);
    setDisplayValue(item.bankName);
    setSearchText(item.bankName);
    bName(item.bankName);
    setShowList(false);
  };

  const handleFocus = () => {
    setShowList(true);
  };

  const filteredBanks = bank.filter((item) =>
    item.bankName.toLowerCase().includes(searchText.toLowerCase())
  );

  return (
    <div className=" w-full relative" ref={dropdownRef}>
      <label className=" mb-3 block">Choose bank</label>
      <input
        className=" bg-white border border-gray-300 p-3 rounded-md w-full"
        value={displayValue}
        onChange={handleChange}
        onFocus={handleFocus}
        placeholder="Search Bank"
        disabled={disabled}
      />

      {showList && (
        <div className="absolute z-50 w-full max-h-[200px] overflow-y-auto bg-white border border-gray-300 rounded-md shadow-lg mt-1">
          {filteredBanks.map((i, index) => (
            <div
              key={`${i.bankCode}-${index}`}
              className="p-3 hover:bg-gray-100 cursor-pointer text-sm text-[#44474E]"
              onClick={() => handleSelect(i)}
            >
              {i.bankName}
            </div>
          ))}
          {filteredBanks.length === 0 && (
            <div className="p-3 text-sm text-gray-500">No bank found</div>
          )}
        </div>
      )}
    </div>
  );
}

export default SelectBank;
